import { Button, Card, Result, Row, Typography } from "antd";
import React from "react";
import { PriceTier } from "../interface";
import PriceReceipt from "../PriceReceipt/PriceReceipt";

const { Title, Text } = Typography;

interface Props {
  bookedDate: Date | undefined;
  priceTiers: PriceTier[];
  description: string | undefined;
}

const Summary: React.FC<Props> = ({ bookedDate, priceTiers, description }) => {
  return (
    <>
      <Card style={{ width: "100%" }}>
        <Result
          status="success"
          title="Arrangementet er booket!"
          subTitle="Bekreftelse er sendt på mail til hovedkontakt. Dette kan ta noen minutter, vennligst vent eller sjekk søppelpost."
        />
        <Row>
          <Title level={5}>Oppsummering</Title>
        </Row>
        <PriceReceipt tiers={priceTiers} selectedDate={bookedDate} style={{ maxWidth: "520px" }} />
        {description && description !== "" && (
          <div style={{ margin: "16px 0" }}>
            <Text strong>Kommentar til Bindeleddet:</Text> {description}
          </div>
        )}
        <div style={{ height: "16px" }} />
        <Row>
          <Text>
            Dere vil få tildelt en hovedansvarlig fra Bindeleddet som tar kontakt i god tid før arrangementet.{" "}
          </Text>
        </Row>
        <Row>
          <Text>
            Ta kontakt på <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a> om dere skulle ha noen
            henvendelser før dette!
          </Text>
        </Row>
        <br />
        <Row>
          <Text italic>Takk for at dere velger å bruke Bindeleddet! </Text>
        </Row>
      </Card>

      <Row style={{ justifyContent: "space-between", width: "100%", padding: "10px 0" }}>
        <Button href="/company/company-profile/" type="primary" size="large" style={{ margin: "auto" }}>
          Tilbake til bedriftssiden
        </Button>
      </Row>
    </>
  );
};

export default Summary;
